<template>
  <settings-modal class="payment-ifast-api-return-to-pending-modal">
    <template slot="heading">{{ heading }}</template>

    <error-alert :error="error" />

    <p class="subheading red--text text-darken-2 mb-0">Are you sure you want to move this payment to manual processing?</p>

    <template slot="actions">
      <v-btn
        id="reject"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentIfastApiReturnToPendingModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        returnIfastApiWithdrawalToPendingByAccountant: new ApiRequest(PaymentApi.returnIfastApiWithdrawalToPendingByAccountant)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      paymentId () {
        return this.modal.data.paymentId
      },
      heading () {
        return `Move payment ${this.paymentId} to manual processing?`
      },
      loading () {
        return this.returnIfastApiWithdrawalToPendingByAccountant.loading
      },
      error () {
        return this.returnIfastApiWithdrawalToPendingByAccountant.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.returnIfastApiWithdrawalToPendingByAccountant
          .execute(this.paymentId)
          .then(this.returnToPendingSuccessHandler)
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      returnToPendingSuccessHandler () {
        this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'The payment has been moved to manual processing.' }
          })
        }, 100)
      }
    }
  }
</script>

<style lang="scss">
.payment-ifast-api-return-to-pending-modal {
  &.settings-modal {
    .container {
      padding-bottom: 28px;
    }
  }
}
</style>
